/* eslint no-unused-vars: [2, { "varsIgnorePattern": "CssConstants" }] */
import CssConstants from 'style/CssConstants';

class ProfileImageConstants {
  static MOBILE_SIZE = CssConstants.MAX_PROFILE_IMG_SIZE_MOBILE;

  static DESKTOP_SIZE = CssConstants.MAX_PROFILE_IMG_SIZE_DESKTOP;

  static MAX_UPLOAD_WIDTH = 1920;

  static MAX_UPLOAD_HEIGHT = 1080;

  static DIAMETER = 34;

  static POLLING_INTERVAL = 2000;
}

export default ProfileImageConstants;
